import React from 'react';
import { createRoot } from 'react-dom/client';
import { component } from 'picoapp';
import CartUpsellsProvider from './CartUpsells';
// import MiniCart from './MiniCart';

export default component((node, ctx) => {
  if (!customElements.get('cart-upsells')) {
    customElements.define(
      'cart-upsells',
      class extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          const props = Object.values(this.attributes).map((attribute) => [attribute.name, attribute.value]);
          // console.log('cart-upsells: ', props);
          // Get free shipping threshold from script tag
          // const freeShippingThreshold = document.querySelector('script[type="application/json"]').getAttribute('free-shipping-threshold');
          // let data = {};
          // try {
          //   data = JSON.parse(this.querySelector('script[type="application/json"]').innerHTML);
          // } catch (error) {}
          const element = <CartUpsellsProvider ctx={ctx} el={this} {...Object.fromEntries(props)} />;
          const root = createRoot(this);
          root.render(element);
        }
      }
    );
  }
});
